module.exports = __webpack_public_path__ + "static/media/md-key.6d57f119.svg";